import React from 'react';
import { Navigate } from 'react-router-dom';
import { resolveMondialiHomeRedirectPath } from '../utils/mondialiRouting';

const MondialiHomeRedirect = () => {
  const targetPath = resolveMondialiHomeRedirectPath(new Date());
  return <Navigate to={targetPath} replace />;
};

export default MondialiHomeRedirect;
